import { Box, IconButton, Menu, MenuItem, Typography } from '@material-ui/core';
import { FunctionComponent } from 'react';

import { useIdeLauncher } from '../../../../../hooks/useIdeLauncher';
import InformationTooltip from '../../../../../shared/informationTooltip';
import { useStyles } from './styled';

export type Props = {
    workToken: string | null;
};

const ExtensionOpenerItem: FunctionComponent<Props> = ({ workToken }: Props) => {
    const classes = useStyles();
    const { anchorEl, launchIde, openMenu, closeMenu } = useIdeLauncher(workToken);

    return (
        <Box
            onMouseEnter={openMenu}
            onMouseLeave={closeMenu}
            className={classes.launchExtensionWrapper}
        >
            <InformationTooltip text="Launch Extension" placement="top">
                <IconButton
                    className="action-icon-btn"
                    aria-controls="launch-menu"
                    aria-haspopup="true"
                    data-testid="launch-extension-button"
                >
                    <img src="vscode.svg" alt="Extension" />
                </IconButton>
            </InformationTooltip>
            <Menu
                id="launch-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={closeMenu}
                MenuListProps={{
                    onMouseLeave: closeMenu
                }}
                classes={{
                    paper: classes.menuPaper
                }}
                getContentAnchorEl={null}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center'
                }}
                disableRestoreFocus
                data-testid="launch-menu"
            >
                <MenuItem 
                    onClick={() => launchIde('vscode')}
                    className={classes.menuItem}
                    data-testid="launch-vscode"
                >
                    <Typography className={classes.menuText}>Launch with VSCode</Typography>
                </MenuItem>
                <MenuItem 
                    onClick={() => launchIde('cursor')}
                    className={classes.menuItem}
                    data-testid="launch-cursor"
                >
                    <Typography className={classes.menuText}>Launch with Cursor</Typography>
                </MenuItem>
                <MenuItem 
                    onClick={() => launchIde('antigravity')}
                    className={classes.menuItem}
                    data-testid="launch-antigravity"
                >
                    <Typography className={classes.menuText}>Launch with AntiGravity</Typography>
                </MenuItem>
            </Menu>
        </Box>
    );
};

export default ExtensionOpenerItem;
